import HtmlParser from 'html-react-parser';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import UserTestimonyCard from '../../components/cards/UserTestimonyCard';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import { PATHS } from '../../utils/urls';

function WistiaPopup() {
	const [modalShow, setModalShow] = React.useState(false);
	const handleModalClose = () => setModalShow(false);
	const handleModalShow = () => setModalShow(true);

	return (
		<div className="d-flex mt-1 mb-1">
			<Button variant="" onClick={handleModalShow} className="cta cta-video">See it in action</Button>

			<Modal show={modalShow} onHide={handleModalClose} centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<ResponsiveEmbed aspectRatio="16by9">
						<ReactPlayer
							url='https://charthop.wistia.com/medias/msgs17xs45'
							playing
							volume={1}
							controls={false}
							width='100%'
							height='100%'
						/>
					</ResponsiveEmbed>

				</Modal.Body>
			</Modal>
		</div>
	);
}

const Home = (props) => {


	const location = props.location;

	return (
		<Layout bodyClass="why-charthop" ontouchstart>
			<SEO title="Why ChartHop | ChartHop | The Org Management Platform" />
			<Helmet>
				<meta name="description" content="Your most strategic work takes place in manual, static, spreadsheets. It's time for an upgrade. The all in one HR solution." />
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Why ChartHop | ChartHop | The Org Management Platform" />
				<meta property="og:description" content="Your most strategic work takes place in manual, static, spreadsheets. It's time for an upgrade. The all in one HR solution." />
				<meta property="og:image" content={`https://www.charthop.com/img/meta-image-why-charthop.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Why ChartHop | ChartHop | The Org Management Platform" />
				<meta name="twitter:description" content="Your most strategic work takes place in manual, static, spreadsheets. It's time for an upgrade. The all in one HR solution." />
				<meta name="twitter:image" content={`https://www.charthop.com/img/meta-image-why-charthop.png`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
			</Helmet>

			{/* HERO CONTENT */}
			<section className="intro sectionSpacing">
                <div className="row contentBlock pt-4 pb-1 align-items-center">
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
                        <h1>Why ChartHop?</h1>
                        <p className="header-p pb-1 pt-1">Your most strategic work takes place in manual, static, spreadsheets. It's time for an upgrade.</p>
                        <div className="splitText"><DemoFormShort source={"product-why-charthop-demo-header"} /></div>  
						<WistiaPopup />                       
                    </div>
                    <div className="reactPlayerContainer col-md-6 order-md-1 padding-top-video-one" >
						<ReactPlayer
							url="/home/02_Reports_03_Optimized.mp4"
							playing
							loop
							muted
							playsinline
						/>
					</div>
                </div>
            </section>

			{/* COSTUMER */}
			<section className="customer backgroundGradientContainer pt-8 pb-5">
				<JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
			</section >

			{/* TESTIMONIAL */}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse pt-0 pb-8" id="Customer Stories">            
				<div className="contentBlock row">
					<div className="col-12"> 
						<UserTestimonyCard
							testimony={<p>
								“ChartHop is the perfect product in a world where <strong>remote</strong> work is the standard, where building <strong>diverse</strong> teams is critical and being <strong>agile</strong> as a business is the only way to <strong>thrive</strong>.”
								</p>}
							logo="/home/brand_logos/bettercloud-logo.svg"
							name="David Politis"
							readMoreButton={false}
							readMoreLink=""
							readMoreText="case studies"
							position="CEO @ BetterCloud"
							image="/home/quotes/DavidPolitis_BetterCloud.jpeg"
						/> 
					</div>
				</div> 
            </section>			

			{/* ORGANIZATIONS */}
			<section className="organizations sectionSpacing pt-7 pb-7">
				<div className="contentBlock">
					<h2 className="text-center">Organizations need more.</h2>
					<div className="svg-info mt-4">
						<div className="svg-info-card-3col">
							<img src={'/product-overview/icons/Diversity_icon.svg'} alt="Diversity" />
							<p>People want to see an org chart - and we’ve got the best in the market.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/product-overview/icons/NewEmployees_icon.svg'} alt="Adaptibility" />
							<p>In the age of remote work, context is more important than ever.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/product-overview/icons/time_travel_icon.svg'} alt="Humanity" />
							<p>The days of rigid planning cycles are over - continuous iteration is a must.</p>
						</div>
					</div>
				</div>
			</section>

			{/* TECHNOLOGY */}			
			<section className="technology sectionSpacing backgroundGradientContainer pt-7 pb-2">
				<div className="container">

					<div className="contentBlock">
						<h2 className="text-center pb-lg-2 pb-5"> But, technology had yet to catch up. <span className="blue-text">Until now.</span></h2>
					</div>

					{/* HR SOLUTIONS */}
					<div name="hr-solutions" id="hr-solutions" className="contentBlock pb-lg-1 pb-7">
						<MultimedialPanel 
							multimediaPosition="right"
							title="There are so many vertical HR solutions it can be hard to see the full picture."
							link="/home/integration_home.mp4"
							type="video"
							paddingClass="padding-top-video-one"
							content={
								<React.Fragment>
									<p>That's why ChartHop centralizes all your data and processes, eliminating additional spend and overhead. </p>
									<p>Performance reviews? We got you. OKRs? We got that too. eNPS? You bet!</p>
									<a href={PATHS.INTEGRATIONS} className="ctaStandard smallMobile">Centralize with seamless integrations </a>
								</React.Fragment>
							}
						/>
					</div>

					{/* PLANNING */}
					<div name="planning" id="planning" className="contentBlock pb-lg-1 pb-7">
						<MultimedialPanel 
							multimediaPosition="left"
							title="Planning is fundamentally broken, filled with manual spreadsheets and incomplete information."
							link="/home/05_Scenario_03_Optimized.mp4"
							type="video"
							paddingClass="padding-top-video-two"
							content={
								<React.Fragment>
									<p>That's why ChartHop provides real-time data and first-of-its-kind headcount and compensation planning modules. 
									</p>
									<p>Now, organizations can be as flexible as these ever-changing times.
									</p>
									<a href={PATHS.PLANNING} className="ctaStandard smallMobile">Plan like you've never planned before </a>
								</React.Fragment>
							}
						/>
					</div>

					{/* DIVERSITY */}
					<div name="diversity" id="diversity" className="contentBlock pb-lg-1 pb-7">
						<MultimedialPanel 
							multimediaPosition="right"
							title="Analyzing diversity data takes so much time, there’s no time for action."
							link="/videos/visualize-dei.mp4"
							type="video"
							paddingClass="padding-top-video-three"
							content={
								<React.Fragment>
									<p>“Companies spend millions trying to figure out if they have pay equity issues or gender gap issues.</p>
									<p>Now there will be no excuse because the data is sitting there -  you can push a button and get it."</p>
									<div className="testimonyAuthor mb-2">
										<img src={'/supporters/aileen-cowboy.png'} alt="Aileen Lee" />
										<div className="d-flex flex-column">
											<p className="my-0 text-left"><b>Aileen Lee</b></p>
											<p className="my-0 minorBlueHeader text-left">Founder & Partner, Cowboy Ventures</p>
										</div>
									</div>
									<a href={PATHS.DEI} className="ctaStandard smallMobile">It's time to act </a>
								</React.Fragment>
							}
						/>
					</div>
					
				</div>				
			</section>
			
            {/* EVERYTHING */}
            <section className="everything sectionSpacing flex-centeredColumn padding-section pt-7 pb-6">
            	<h2 className="text-center mt-0 sectionSpacing-Margin ">Everything you need in one platform</h2> 
            	<div className="flex-centeredColumn contentBlock">
					<div className="flex-platform svg-info-card-everything">
						<div className="svg-info-card-3col2">
							<img src={'/product/org-chart/data-centralization.svg '} alt="Visualize" />
							<p className="">Data Centralization</p>
						</div>
						<div className="svg-info-card-3col2">
							<img src={'/product/org-chart/visualize.svg'} alt="Put a face to the name" />
							<p className="">Org Chart & Employee Profiles</p>
						</div>
						<div className="svg-info-card-3col2 ">
							<img src={'/product/org-chart/people-analytics.svg'} alt="Time Saving" />
							<p className="">People Analytics</p>
						</div>
						<div className="svg-info-card-3col2">
							<img src={'/product/org-chart/compensation.svg'} alt="Transparency" />
							<p className="">Compensation & Headcount Planning</p>
						</div>
						<div className="svg-info-card-3col2">
							<img src={'/product/org-chart/performance.svg'} alt="Work" />
							<p className="">Performance Reviews</p>
						</div>          
					</div>
				</div>
            </section>

			{/* BUILT */}
			<section className="built backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn pt-7">
            	<h2 className="text-center mt-0 sectionSpacing-Margin">Built to augment your existing tools.</h2> 
            	<h4 className="text-center mt-0 sectionSpacing-Margin">Seamless integrations means you can get up and running in as little as 30 minutes.</h4>
            	<div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack"/>
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                        </div>
                        {/* FIRST 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>
                        {/* SECOND 4 */} 
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" />
                            </div>
                        </div>
                        <div>
                            <div>
								<img src='/integrations/logos/gusto.png' alt="Gusto" /> 	
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-rippling@2x.jpg' alt="Rippling" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" />
                            </div>
                        </div>
                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/sequoia.png' alt="Sequoia" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" />
                            </div>
                        </div>
                        
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/zenefits.png' alt="Zenefits" />
                            </div>
                        </div>  
                        {/* PSEUDO */}
                        <div className="psudeo ps1">
                        </div>
                        <div className="psudeo ps2">
                        </div>
                        <div className="psudeo ps3">
                        </div>
                        <div className="psudeo ps4">
                        </div>                        
                        <h4 className="text-center">& more</h4>
                    </div>
                </div>
            </section>

			{/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo pt-3 pb-4 pt-md-7 pb-md-8">
				<DemoFormLong source={"product-why-charthop-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class="mb-3 contact-testimonial">"ChartHop helped us replace our mundane, outdated processes - there is nothing else like it. </br><br/> I can not imagine what we would do without ChartHop.”</p><div class="authorTag"><img src="/home/quotes/quote_DavidDankenbrink@2x.jpg" class="testimonialAuthor" alt="David Dankenbrink" /><div><p class="contactAuthor"><strong>David Dankenbrink</strong> <br>Vice President, Human Resources @ Remy Cointreau</p></div></div>')}/>
			</section>
		</Layout>
	);
};


export default Home;
